import sessionStorageSingleton from '../../../../core/configs/sessionStorageSingleton';
import {
  exportFeKey,
  importFeKey,
} from '../../../../core/cryptor/keyPairCrypto';
import { startReadSheet } from '../../../storage/managers/ReadManager';
import { Sheet } from '../../../types';
import {
  CreateSheet,
  DeleteSheet,
} from '../../../types/commands/sheetCommands/sheetCommands';
import { SheetManagementSet } from '../../../types/sheet/draft';
import {
  createSheetCommand,
  deleteSheetCommand,
} from '../generate/generateSheetCommands';
import {
  addEntityIdToName,
  removeFromEntityIdToName,
} from '../../entityIdToName/entityIdToName';
import { createSheetDefaultView } from '../../views/views';

// #region create sheet
export async function createSheet(set: SheetManagementSet, op: CreateSheet) {
  const { sheet } = op;

  if (!sheet.usersPreferences[set.userId])
    sheet.usersPreferences[set.userId] = {};

  const preferences = sheet.usersPreferences[set.userId];

  let groupId = op.groupId; // ?? preferences.groupId ?? uuid();

  if (!preferences.groupId && groupId) {
    sheet.usersPreferences[set.userId] = { ...preferences, groupId };
  }

  let exportedFeKey: string = '';
  if (op.exportedFeKey) {
    const sheetFeKey: CryptoKey = await importFeKey(op.exportedFeKey);
    await sessionStorageSingleton.generateAndSaveFeKey(sheet.id, sheetFeKey);
  } else {
    const sheetFeKey = await sessionStorageSingleton.generateAndSaveFeKey(
      sheet.id
    );
    if (sheetFeKey) {
      exportedFeKey = await exportFeKey(sheetFeKey);
    }
  }

  createSheetCommand(set, sheet, exportedFeKey, groupId);

  addEntityIdToName(set, sheet);

  // set.updatedSheets.set(sheet.id, sheet);
  set.temporarySheets.set(sheet.id, sheet);
}
// #endregion

// #region delete sheet
export async function deleteSheet(set: SheetManagementSet, op: DeleteSheet) {
  const { sheetId, groupId } = op;

  const feKey = await sessionStorageSingleton.getFeKey(sheetId);
  if (!feKey) throw new Error('Sheet Fe Key not found');
  const exportedFeKey: string = await exportFeKey(feKey);

  const entityIdToNameMap =
    set.updatedEntityIdToNameMap ?? set.staticEntityIdToNameMap;
  const doesSheetExists = !!entityIdToNameMap.sheetsIdToName[sheetId];

  if (doesSheetExists) {
    const sheet: Sheet | undefined = await getStaticSheet(set, sheetId);

    if (sheet) deleteSheetCommand(set, sheet, exportedFeKey, groupId);

    set.deletedSheets.add(sheetId);

    removeFromEntityIdToName(set, sheetId);
  }
}
// #endregion

// #region get static sheet
export async function getStaticSheet(set: SheetManagementSet, sheetId: string) {
  let sheet: Sheet | undefined =
    set.temporarySheets.get(sheetId) ?? set.staticSheets[sheetId];

  // if (!sheet) {
  // Update We have changed the logic the sheet is now inside temporary sheet
  //   // In case sheet is created with creation command You will get the full sheet in updated sheet
  //   const updatedSheet = set.updatedSheets.get(sheetId);
  //   const ownerId = updatedSheet?.ownerId;
  //   const name = updatedSheet?.name;
  //   if (updatedSheet && ownerId && name)
  //     sheet = generateSheet(ownerId, name, updatedSheet);
  // }

  if (!sheet) {
    sheet = await startReadSheet(set, sheetId);
  }

  return sheet;
}

export function getStaticSheetView(set: SheetManagementSet, sheetId: string) {
  let sheetView = set.staticSheetViews[sheetId];
  if (!sheetView) {
    sheetView = createSheetDefaultView();
  }
  return {
    ...sheetView,
    ...(set.updatedSheetViews.get(sheetId) ?? {}),
  };
}
// #endregion
